import axios from 'axios';
import settings from '../settings';

export const capableApi = axios.create({ baseURL: settings.apiUrl, withCredentials: true });

export const medicationApi = axios.create({ baseURL: settings.medApiUrl });

export const felleskatalogenLookupApi = axios.create({ baseURL: 'https://felleskatalogen-lookup.herokuapp.com/' });
